module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/2@2x_51a0b45622646cb5ea55289c878d9e63.png";